<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">门诊预约及服务时间</h3>
            <p class="depth">您可以通过电话、电子邮件或网站等方式进行预约. 如需安排预约和治疗，须提供您的个人信息并详细描述您的症状.</p>
            <div class="table mt20">
                <table>
                    <caption>Outpatient Appointment and Service Hours (For how to make an appointment, Process,
                        Available time)</caption>
                    <colgroup>
                        <col style="width: 25%">
                        <col style="width: auto">
                        <col style="width: 15%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">预约方式</th>
                            <th scope="col">流程</th>
                            <th scope="col">预约时间</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>电话</td>
                            <td>请致电国际医疗保健中心(+82-6986-3100)</td>
                            <td>09:00 ~ 17:00</td>
                        </tr>
                        <tr>
                            <td>电邮地址</td>
                            <td><a href="mailto:eumcint@gmail.com">eumcint@gmail.com</a></td>
                            <td>24小时</td>
                        </tr>
                        <tr>
                            <td>网站</td>
                            <td>
                                <div style="display: ruby;">
                                    您也可以通过医院网站在线预约. 转到我们的网站
                                    &nbsp;&nbsp;
                                    <a href="/eng/reservation/reservation.do"
                                        class="main-button small c-main">预约</a>
                                </div>
                            </td>
                            <td>24小时</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">更改或取消治疗 (预约)</h3>
            <p class="depth">
                如果您因任何原因不能按照约定时间就诊, 请至少在变更或取消预约前一天联系我们.
            </p>
            <div class="table mt20">
                <table>
                    <caption>Change or Cancelation of Service (For how to make an appointment, Process)</caption>
                    <colgroup>
                        <col style="width: 25%;">
                        <col>
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">预约方式</th>
                            <th scope="col">流程</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>电话</td>
                            <td>请致电国际医疗保健中心 (+82-6986-3100)</td>
                        </tr>
                        <tr>
                            <td>电邮地址</td>
                            <td><a href="mailto:eumcint@gmail.com">eumcint@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>